"use client";

import Link from "next/link";
import { AlertTriangle, ArrowRight, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { getErrorCopy, type AppErrorCode } from "@/lib/error-config";

export function ErrorState({ code = "UNKNOWN", onRetry, reference }: { code?: AppErrorCode; onRetry?: () => void; reference?: string }) {
  const copy = getErrorCopy(code);
  const action = copy.actionHref ? <Button asChild><Link href={copy.actionHref}>{copy.actionLabel}<ArrowRight size={15} /></Link></Button> : <Button onClick={onRetry}><RefreshCw size={15} />{copy.actionLabel}</Button>;
  return <main className="error-page"><Card className="error-card"><div className="error-icon"><AlertTriangle size={26} /></div><p className="eyebrow">facility360</p><h1>{copy.title}</h1><p className="lede">{copy.message}</p><div className="error-actions">{action}</div>{reference && <p className="error-reference">Reference: {reference}</p>}</Card></main>;
}
